module.exports = __webpack_public_path__ + "static/media/ascentarc-3.1b293a6e.jpg";